import { formatCurrency } from "src/utils/formatCurrency";
import { Button, SchedulePopup } from "src/components/shared";
import { useStore } from "../../../../../store";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { useState } from "react";

const ClassEnrollment = () => {
  const navigate = useNavigate();
  const { courseStore, userStore } = useStore();
  const session = courseStore?.classDetails;

  const [isScheduleOpen, setIsScheduleOpen] = useState(false);

  const hasDiscount = session?.newSessionDiscount > 0;
  const price = hasDiscount
    ? session?.price * (1 - session?.newSessionDiscount / 100)
    : session?.price;

  const bookingRoom = session?.sessionBooking?.[0]?.bookingRoom;

  const getNumberOfDaysLeft = () => {
    const datePart = moment(session?.end).format("YYYY-MM-DD");
    const timePart = moment(session?.endDate).format("HH:mm:ssZ");

    const startDateTime = moment(`${datePart}T${timePart}`);

    const now = moment();

    const daysLeft = startDateTime.diff(now, "days");
    const hoursLeft = startDateTime.diff(now, "hours");

    if (daysLeft > 0) {
      return `${daysLeft} ${daysLeft !== 1 ? "Days" : "Day"} Left to Enroll`;
    } else if (hoursLeft > 1) {
      return `${hoursLeft} Hours Left to Enroll`;
    } else if (hoursLeft === 1) {
      return "1 Hour Left to Enroll";
    } else {
      return "Enrollment Closed";
    }
  };

  const participate = async () => {
    navigate(`/payment/${session?.id}`);
  };

  return (
    <div className="px-5 sm:px-8 py-4">
      <div className="flex flex-col">
        <div className="flex justify-between px-5 py-3 bg-primary-purple-100 rounded-tl-[20px] rounded-tr-[20px]">
          <p className="body-medium">Enroll for this class</p>
          <div className="flex flex-wrap flex-col-reverse sm:flex-row items-end sm:items-center gap-2">
            <div className="flex items-center gap-1">
              {hasDiscount && (
                <span className="caption-text text-primary-purple-900 opacity-60 line-through">
                  {formatCurrency(session?.price, userStore?.currency)}
                </span>
              )}
              <span className="body-medium-bold text-primary-purple-500">
                {price ? formatCurrency(price, userStore?.currency) : "FREE"}
              </span>
            </div>
            {hasDiscount && (
              <div className="caption-text-bold px-3 py-1 bg-primary-paradise-pink-500 text-white rounded-full">
                {session?.newSessionDiscount}% OFF
              </div>
            )}
          </div>
        </div>

        <div className="flex flex-col items-center gap-2.5 px-5 py-2.5 bg-primary-purple-50 border-l border-r border-b border-primary-navy-blue-100 rounded-bl-[20px] rounded-br-[20px]">
          {session?.isOnline ||
          bookingRoom?.size > session?.subscriptionsSession?.length ? (
            <>
              <p className="caption-text-bold flex items-center gap-1.5 text-primary-purple-750">
                <img src="/images/icons/clock-purple.svg" />
                {getNumberOfDaysLeft()}
              </p>
              <div className="flex flex-col gap-1.5 w-full">
                <Button
                  type="primary_dark"
                  text="Book a Seat"
                  onClick={participate}
                />
                <Button
                  type="pale"
                  text="View Class Schedule"
                  onClick={() => setIsScheduleOpen(true)}
                />
              </div>
            </>
          ) : (
            <div className="flex flex-col items-center gap-2.5 py-5">
              <img src="/images/icons/no-class.svg" />
              <p className="caption-text-bold text-primary-purple-750">
                Class is fully booked...
              </p>
            </div>
          )}
        </div>
      </div>

      {isScheduleOpen && (
        <SchedulePopup
          id={session?.id}
          planning={session?.planning}
          scheduleData={session?.scheduleData}
          isOpen={isScheduleOpen}
          closePopup={() => setIsScheduleOpen(false)}
        />
      )}
    </div>
  );
};

export default ClassEnrollment;
